import {
  DELETE_CREDIT_CODE,
  VALIDATE_CREDIT_CODE_REQUEST,
  VALIDATE_CREDIT_CODE_SUCCESS,
  VALIDATE_CREDIT_CODE_FAILURE,
  CreditCode,
  RESET_CREDIT_CODE_STATUS,
  DELETE_ALL_CREDIT_CODES,
  RESTORE_PERSISTED_CREDIT_CODES,
} from 'types/credit-codes';
import * as appTypes from 'types/app';
import initialState from 'store/initial-state';
import i18n from 'i18next';
import { persistCreditCodes } from 'utils/checkoutPricingStorage';

type CreditCodeAction =
  | {
      type: string;
      payload: {
        creditCode: CreditCode;
        responseStatus: number;
        validationMessages: string;
        code?: string;
      };
      error: string;
    }
  | {
      type: typeof RESTORE_PERSISTED_CREDIT_CODES;
      payload: { creditCodes: CreditCode[] };
    };

export default function creditCodesReducer(
  state = initialState.creditCodes,
  action: CreditCodeAction,
) {
  switch (action.type) {
    case DELETE_CREDIT_CODE: {
      const { code } = action.payload;
      const remaining = state.creditCodes.filter(
        (creditCode: CreditCode) => creditCode.code !== code,
      );
      persistCreditCodes(remaining);
      return {
        ...state,
        creditCodes: remaining,
        error: '',
        message: '',
      };
    }
    case DELETE_ALL_CREDIT_CODES:
      persistCreditCodes([]);
      return {
        ...state,
        creditCodes: [],
      };
    case VALIDATE_CREDIT_CODE_REQUEST:
      return {
        ...state,
        error: '',
        message: '',
        responseStatus: null,
        validateCreditCodeStatus: appTypes.STATUS_PENDING,
      };
    case VALIDATE_CREDIT_CODE_SUCCESS: {
      const newCreditCode = action.payload.creditCode;
      const existingCreditCodes = state.creditCodes;
      const existingCodes = new Set(
        existingCreditCodes.map((code: CreditCode) => code.code),
      );

      if (existingCodes.has(newCreditCode.code)) {
        return {
          ...state,
          validateCreditCodeStatus: appTypes.STATUS_FAILURE,
          error: i18n.t('creditCodeHasAlreadyBeenApplied'),
        };
      }

      const updatedCodes = [...state.creditCodes, action.payload.creditCode];
      persistCreditCodes(updatedCodes);
      return {
        ...state,
        creditCodes: updatedCodes,
        validateCreditCodeStatus: appTypes.STATUS_SUCCESS,
      };
    }
    case RESET_CREDIT_CODE_STATUS:
      return {
        ...state,
        error: '',
        message: '',
        responseStatus: null,
        validateCreditCodeStatus: '',
      };
    case VALIDATE_CREDIT_CODE_FAILURE:
      persistCreditCodes([]);
      return {
        ...state,
        creditCodes: [],
        validateCreditCodeStatus: appTypes.STATUS_FAILURE,
        responseStatus: action.payload.responseStatus,
        validationMessages: action.payload.validationMessages,
        error:
          action.error || action.payload.responseStatus === 404
            ? i18n.t('invalidCodeValidation')
            : i18n.t('networkErrorCreditCode'),
      };
    case RESTORE_PERSISTED_CREDIT_CODES:
      return {
        ...state,
        creditCodes:
          (action as { payload: { creditCodes: CreditCode[] } }).payload
            .creditCodes ?? [],
      };
    default:
      return state;
  }
}
